import * as React from 'react'

import { useBloomreachPageRoutes, useBloomreachProductRoutes } from '@grandvisionhq/bloomreach'
import { ProductDetailSlotsProvider } from '@grandvisionhq/fun-products'
import { NextPage, withErrorPage } from '@grandvisionhq/next'
import { CrossSellProducts } from '@grandvisionhq/search'
import { useFeatureToggles } from '@grandvisionhq/state'
import { compose } from '@grandvisionhq/utils'
import {
  ErrorCase,
  InitialProps,
  LegacyPage,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail-legacy'

import { withCms, withLayout } from '../../cms'
import { defaultErrorProps } from '../../components/error-props'
import OpticianForm from '../../components/forms/Optician'
import { settings as cartSettings, withCart } from '../../components/hocs/with-cart'
import { PromoteInstallmentsRestContainer as PromoteInstallments } from '../../components/slot-components'
import { getDeliveryIndicatorConfig, getSpecifications } from '../../configuration'
import { getAlgoliaCrossSellConfig } from '../../util/algolia'
import '@grandvisionhq/lib-lime/css'

import '@grandvisionhq/reviews/dist/index.css'

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()
  const { routes } = useBloomreachPageRoutes()
  const [_, { formatProductUrl }] = useBloomreachProductRoutes()
  const { isCrossSellEnabled } = useFeatureToggles()

  if ('statusCode' in props) {
    // If an error status code was returned, render the error page.
    return null
  }

  const crossSellConfig = getAlgoliaCrossSellConfig(props.productType)
  const specifications = getSpecifications(props.productType)

  // We need to map appointment-book to book-appointment, since it's hardcoded in core.
  const adjustedRoutes = {
    ...routes,
    'book-appointment': routes['appointment-book'],
  }

  const SecondaryProductInfoSlotB = isCrossSellEnabled
    ? () => (
        <CrossSellProducts formatProductUrl={formatProductUrl} algoliaConfig={crossSellConfig} />
      )
    : undefined

  const AfterPrice = () => <PromoteInstallments priceType="item" productType={props.productType} />

  return (
    <ProductDetailSlotsProvider
      slots={{
        AfterPrice,
        SecondaryProductInfoSlotB,
      }}
    >
      <LegacyPage
        {...props}
        adjustedPageRoutes={adjustedRoutes}
        deliveryIndicatorConfig={deliveryIndicatorConfig}
        maxOrderableQuantity={cartSettings.maximumQuantity}
        opticianForm={OpticianForm}
        specificationConfiguration={specifications}
      />
    </ProductDetailSlotsProvider>
  )
}

ProductDetailPage.getInitialProps = LegacyPage.getInitialProps

export default compose<Props, Props>(
  withCms(),
  withErrorPage(defaultErrorProps),
  withLayout(),
  withCart({ readOnly: true })
)(ProductDetailPage)
